import PropTypes from 'prop-types';

export const Props = {
  /**
   * Give the image a specific ID
   */
  id: PropTypes.string,
  /**
   * Source of the image
   */
  source: PropTypes.string,
  /**
   * Alt text for the image
   */
  alt: PropTypes.string,
  /**
   * Default image to display before the lazy-loading is initiated.<br/><i style="background-color:#ffc40026;">NOTE: Default value is a 1x1 px transparent gif (base64-encoded)</i>
   */
  placeholder: PropTypes.string,
  /**
   * Type of image to render.<br/><i style="background-color:#ffc40026;">NOTE: Either a background-image or inline img-tag</i>
   */
  type: PropTypes.oneOf(['background', 'image']),
  /**
   * If set, this callback will be triggered after the image is loaded
   */
  callback: PropTypes.func,
  /**
   * For CSS customization
   */
  wrpClassName: PropTypes.string,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
